<template>
  <div class="levo__menu">
    <div
      class="levo__menu__item"
      v-for="item in allGameTabs"
      :key="item.component"
      :class="{ active: isItemActive(item.component) }"
      v-on:click="selectItem(item)"
    >
      <div class="levo__menu__item__obsah" v-if="isPermissions(item.onlyAdmin)" >
        <div class="levo__menu__item__obsah__text">{{ item.name }}</div>

        <div class="levo__menu__item__obsah__obrazek">
          <div :class="item.iconClass"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "LevoMenu",
  data: function () {
    return {
      allGameTabs: [
        {
          name: "All Games",
          component: "allGames",
          iconClass: "gameOverview",
          onlyAdmin: false
        },
         {
           name: "New Game",
           component: "newGame",
          iconClass: "editProducts",
           onlyAdmin: false
         },
         {
           name: "Users",
           component: "users",
          iconClass: "editProducts",
           onlyAdmin: true
         }
      ],
    };
  },
  methods: {
    selectItem: function (item) {
      if(this.isPermissions(item.onlyAdmin)){
        this.$router.push("/gameManager/" + item.component);
      }
    },
    isItemActive: function (name) {
      return "GameManager." + name == this.$route.name;
    },
    isPermissions(onlyAdmin){
      if(onlyAdmin == false){
        return true
      }else{
        if(this.amIAdmin){
          return true
        }else{
          return false
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      amIAdmin: "amIAdmin",
    }),
  },
};
</script>
